export default __webpack_public_path__ + "static/media/CCG_MULTI.6535f1f9.png";